const o = function(e, ...t) {
  return new Promise((n) => n(e.call(this, ...t)));
};
export {
  o as tryResolve
};
